import { Controller } from 'stimulus';

import { uiService } from '../libs/ui_service';

// This is a dummy controller to do all the app initialization
export default class extends Controller {
  initialize() {
    uiService.init();
    uiService.updateTable();
    uiService.applyDefaultTableSort();
  }
}
